import { ExaminationModelResponse } from '@/pages/ScreeningPage/screeningController'
import { ScreeningModel } from '@/pages/ScreeningPage/screeningModel'

export type ExaminationValueType = 0 | 1 | 2 | 3 | 4
export type ScreeningSextants = 'I' | 'II' | 'III' | 'IV' | 'V' | 'VI'
export type ExaminationNumbers =
  | '14-17'
  | '13-23'
  | '24-27'
  | '34-37'
  | '33-43'
  | '44-47'

export class ExaminationModel extends ScreeningModel {
  furcation: boolean
  value: ExaminationValueType
  isActive: boolean

  constructor(cell: ExaminationModelResponse) {
    super(cell.id)
    this.furcation = cell.furcation
    this.isActive = cell.is_active
    this.value = cell.value
  }

  public getCellForSend(): ExaminationModelResponse {
    return {
      furcation: this.furcation,
      is_active: this.isActive,
      value: this.value,
      id: this.id,
    }
  }

  public switchStatusCell(): void {
    this.isActive = !this.isActive
  }

  public switchStatusFurcation(): void {
    this.furcation = !this.furcation
  }

  public changeExaminationValue(): void {
    if (this.value < 4) {
      this.value++
      return
    }

    this.value = 0
  }
}
